import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Grid, Typography, Divider } from "@material-ui/core";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginBottom: "0.1rem",
  },
  divider: {
    margin: "1rem 0",
  },
}));

const OrderEditTrx = () => {
  const classes = useStyles();
  const { order, transactions, getTransactions } = useContext(OrderContext);
  const [trx, setTrx] = useState([]);
  const [vendor, setVendor] = useState("");

  useEffect(() => {
    if (order.transaction_id) {
      let arr = [];

      order.transaction_id.map((each) => {
        if (each !== null && !arr.includes(each)) {
          arr.push(each);
        }
      });

      setTrx(arr);
    }

    // Get Transactions
    getTransactions(order.store_name, order.id);
  }, [order]);

  useEffect(() => {
    // Retrieve Vendor From Transaction
    if (transactions && transactions.length > 0) {
      let vendor = "";

      transactions.forEach((each) => {
        if ("vendor" in each.receipt) {
          vendor = "- " + each.receipt.vendor;
        }
      });

      setVendor(vendor);
    }
  }, [transactions]);

  return (
    <Grid container direction="column">
      <Paper className={classes.paper}>
        {" "}
        {/* Gateway */}{" "}
        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Grid item>
            <Typography variant="body1" className={classes.title}>
              Gateway{" "}
            </Typography>{" "}
          </Grid>
          <Grid item>
            {" "}
            {order.gateway ? `${order.gateway} ${vendor}` : "No gateway"}{" "}
          </Grid>{" "}
        </Grid>
        <Divider className={classes.divider} orientation="horizontal" />
        {/* Transaction */}{" "}
        <Grid
          container
          spacing={1}
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Grid item>
            <Typography variant="body1" className={classes.title}>
              Transaction{" "}
            </Typography>{" "}
          </Grid>
          <Grid item>
            {" "}
            {trx.length > 0 ? (
              trx.map((each, index) => {
                return (
                  <Grid item key={index}>
                    {" "}
                    {each}{" "}
                  </Grid>
                );
              })
            ) : (
              <Grid> No transaction </Grid>
            )}{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Paper>{" "}
    </Grid>
  );
};

export default OrderEditTrx;
